<div class="form-inline appointment-filter">
  <div class="form-group row ms-0 me-0">
    <div class="col-12">
      <strong translate>GENERAL_REUSABLE.FILTER.FILTER_BY</strong>
    </div>

    <div class="col-12 col-md-8">
      <div class="filter-group pb-2">
        <button id="btnSoonest" class="btn btn-link" (click)="soonestAvail = !soonestAvail">
          @if (soonestAvail) {
            <span class="fas fa-lg fa-check-square"></span>
          }
          @if (!soonestAvail) {
            <span class="far fa-lg fa-square"></span>
          }
          <span translate>GENERAL_REUSABLE.FILTER.SOONEST</span>
        </button>

        <strong translate>GENERAL_REUSABLE.FILTER.OR</strong>

        <label for="appointmentScope" translate>GENERAL_REUSABLE.FILTER.APPTS</label>

        <select name="appointmentScope" [(ngModel)]="onBy" id="appointmentScope" class="form-select d-inline-flex">
          <option value="on" selected translate>GENERAL_REUSABLE.FILTER.ON</option>
          <option value="by" translate>GENERAL_REUSABLE.FILTER.BY</option>
        </select>
        <label for="appointmentDate">
          <input type="text" id="appointmentDate"  style="margin-bottom: 5px" [(ngModel)]="filterDate"
            class="form-control date-widget-field d-inline-flex fw-bold"
            attr.aria-label="{{'SCHEDULE_INTERVIEW.DATE_TXT' | translate}} (mm/dd/yyyy)"/>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <strong translate>GENERAL_REUSABLE.FILTER.WITH</strong>

      <div class="filter-group d-inline-flex align-items-center">
        <label for="numberOfAppointments" translate>GENERAL_REUSABLE.FILTER.NUM_APPTS</label>
        <select name="numberOfAppointments" [(ngModel)]="numAppts" id="numberOfAppointments" class="form-select d-inline-block">
          <option value="" selected translate>GENERAL_REUSABLE.FILTER.ANY</option>
          <option value="1">1+</option>
          <option value="2">2+</option>
          <option value="3">3+</option>
          <option value="4">4+</option>
          <option value="5">5+</option>
          <option value="6">6+</option>
          <option value="7">7+</option>
          <option value="8">8+</option>
          <option value="9">9+</option>
          <option value="10">10+</option>
        </select>
      </div>
    </div>

    <div class="col-12">
      <button id="btnApply" class="btn btn-lg btn-primary" (click)="applyFilter()">
        <span translate>GENERAL_REUSABLE.FILTER.APPLY</span>
      </button>
      <button id="btnReset" class="btn btn-link" (click)="resetFilter()">
        <strong translate>GENERAL_REUSABLE.FILTER.CLEAR_ALL</strong>
      </button>
    </div>

  </div>
</div>